export default "__VITE_ASSET__Dv0tWTG4__"